import { render, staticRenderFns } from "./boost_check.vue?vue&type=template&id=2b90f8f4&scoped=true"
import script from "./boost_check.vue?vue&type=script&lang=js"
export * from "./boost_check.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b90f8f4",
  null
  
)

export default component.exports